import React, {useEffect} from 'react';
import Box from "@mui/material/Box";
import {Alert} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import Typography from "@mui/material/Typography";
import {PictureAsPdf} from "@mui/icons-material";
import {useSelector} from "react-redux";
import config from '../../config'
import {useGetEventResourcesQuery} from "../../slices/apiSlice";
import {eventResourceCategory} from "../../util/standards-util";
import UploadWidget from "../../components/Upload/UploadWidget";
import Link from "@mui/material/Link";

const EventInfo = () => {
    const event = useSelector(state => state.session.event)

    const [hasInfo, setHasInfo] = React.useState(true)
    const [files, setFiles] = React.useState({})

    const {data: fileData, refetch, isSuccess: isFilesSuccess} = useGetEventResourcesQuery({eventId:event?.id},{skip: event === undefined})

    const download = (url) => {
        window.open(url, "_blank");
    }

    const onUploadComplete = () => {
        refetch()
    }

    useEffect(() => {
        if (isFilesSuccess){
            const files={
                lps:[],
                airspace:[],
                waypoints:[],
                documents:[],
            }

            fileData.forEach(f => {
                switch(f.category) {
                    case eventResourceCategory.LOCAL_PROCEDURES:
                        files.lps.push(f)
                        break;
                    case eventResourceCategory.AIRSPACE_FILE:
                        files.airspace.push(f)
                        break;
                    case eventResourceCategory.WAYPOINT_LIST:
                        files.waypoints.push(f)
                        break;
                    default:
                        files.documents.push(f)
                }
            })

            setFiles(files)
        }
    }, [isFilesSuccess,fileData]);

    return (
        <>
            <Box>
                {!hasInfo &&
                    <Alert severity={'info'}>No information yet</Alert>
                }
                {hasInfo &&
                    <Grid2 container sx={{textAlign:'left'}}>
                        <Grid2 xs={12} md={9}>
                            {files.lps?.length>0 &&
                                <Box sx={{height:'80vh'}}>
                                    <object
                                        data={config.s3Url+files.lps[0].objUri}
                                        width="100%"
                                        height="100%"
                                    />
                                </Box>
                            }
                        </Grid2>
                        <Grid2 xs={12} md={3}>
                            <Box sx={{minHeight:'50vh',marginLeft:{md:'32px'},paddingLeft:{md:'32px'},borderLeft:{md:'1px solid #999999'}}}>
                                    <Box>
                                        <Typography variant={'h3'} component={'div'} mb={2}>Rules</Typography>
                                            <Link href={`https://s3.amazonaws.com/static.crosscountry.aero/sgp/rules/sgp-rules-v${event?.series}.pdf`} target='_blank' sx={{textDecoration:'none'}}>
                                                <Box mt={1} sx={{display:'flex',alignItems:'center'}} >
                                                    <Typography variant={'body1'} mr={2}>SGP Rules v.{event?.series}</Typography>
                                                    <PictureAsPdf fontSize={'small'} sx={{color:'#666666'}}/>
                                                </Box>
                                            </Link>
                                        {files.lps?.length>0 &&
                                            <Link href={config.s3Url+files.lps[0].objUri} target='_blank' sx={{textDecoration:'none'}}>
                                                <Box mt={1} sx={{display:'flex',alignItems:'center'}}>
                                                    <Typography variant={'body1'} mr={2}>Local procedures</Typography>
                                                    <PictureAsPdf fontSize={'small'} sx={{color:'#666666'}}/>
                                                </Box>
                                            </Link>
                                        }
                                    </Box>
                                    {files.airspace?.length>0 && false &&
                                        <Box mt={4}>
                                            <Typography variant={'h3'} component={'div'} mb={2}>Airspace files</Typography>
                                            {files.airspace.map( f => (
                                                <Link href={config.s3Url+f.objUri} key={f.id} target='_blank' sx={{textDecoration:'none'}}>
                                                    <Box mt={1} sx={{display:'flex',alignItems:'center'}}>
                                                        <Typography variant={'body1'} mr={2}>{f.filename}</Typography>
                                                    </Box>
                                                </Link>
                                            ))}
                                        </Box>
                                    }
                                    {files.waypoints?.length>0 && false &&
                                        <Box mt={4}>
                                            <Typography variant={'h3'} component={'div'} mb={2}>Waypoint files</Typography>
                                        </Box>
                                    }
                                    {files.documents?.length>0 &&
                                        <Box mt={4}>
                                            <Typography variant={'h3'} component={'div'} mb={2}>Documents</Typography>
                                            {files.documents.map( f => (
                                                <Link href={config.s3Url+f.objUri} target='_blank' key={f.id} sx={{textDecoration:'none'}}>
                                                    <Box mt={1} sx={{display:'flex',alignItems:'center'}}>
                                                        <Typography variant={'body1'} mr={2}>{f.filename}</Typography>
                                                    </Box>
                                                </Link>
                                            ))}
                                        </Box>
                                    }
                                </Box>
                        </Grid2>
                    </Grid2>
                }
            </Box>
            <UploadWidget onUploadComplete={onUploadComplete}/>
        </>
    );
};

export default EventInfo;